export const LOADING_MESSAGE = 'LOADING_MESSAGE';
export const LOADING_STATUS = 'LOADING_STATUS';